import type { AssistantContextCompactionTimelineItem } from "../types";
import { AssistantTranscriptMarkerDivider } from "./assistant-transcript-marker-divider";

interface AssistantContextCompactionDividerProps {
  /**
   * Only what the divider renders. Narrow on purpose: an activity turn shows the same marker for
   * a compaction that never became a timeline row of its own, and it has no identity stamps to
   * hand over.
   */
  item: Pick<AssistantContextCompactionTimelineItem, "text" | "status">;
  compact?: boolean;
  embedded?: boolean;
}

export function AssistantContextCompactionDivider({
  item,
  compact = false,
  embedded = false,
}: AssistantContextCompactionDividerProps) {
  return (
    <AssistantTranscriptMarkerDivider
      text={item.text}
      compact={compact}
      embedded={embedded}
      running={item.status === "running"}
      tone={item.status === "failed" ? "destructive" : "default"}
      testId="assistant-context-compaction-divider"
      labelTestId="assistant-context-compaction-label"
      data-status={item.status}
    />
  );
}
